<template>
  <router-link
    :to="detailsLink"
    class="market-contract-info-v2"
    @click="fireContractPriceListClick"
  >
    <div class="market-contract-info-v2__compact" v-if="isCompactLayout">
      <div
        class="market-contract-info-v2__image"
        :style="imageStyleModifiers"
        v-if="imageUrl"
      ></div>
      <div class="market-contract-info-v2__main">
        <div class="market-contract-info-v2__title" v-if="!!$slots.title || title">
          <slot name="title" v-if="!!$slots.title"></slot>
          <span v-else-if="title">{{ title }}</span>
        </div>
        <div class="market-contract-info-v2__subtitle" v-if="!!$slots.subtitle">
          <slot name="subtitle"></slot>
        </div>
        <div class="market-contract-info-v2__content">
          <slot name="preContent"></slot>
          <template v-if="layout === MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK">
            <slot name="content"></slot>
          </template>
          <template v-if="layout === MARKET_CONTRACT_INFO_VALUES_LAYOUT.CONTRACTS_SUMMARY">
            <div
              class="market-contract-info-v2__row"
              :key="contractKey(item)"
              v-for="item in marketContracts"
            >
              <div class="market-contract-info-v2__value-light" v-contract-name>
                {{ contractTitle(item) }}
              </div>
              <div class="market-contract-info-v2__value-dark market-contract-info-v2--mono">
                <market-change-price
                  v-if="contractChanePrice(item)"
                  :price="contractChanePrice(item)"
                  :lastClosePrice="contractLastClosePrice(item)"
                  :symbol="priceSymbol"
                ></market-change-price>
                <template v-if="contractHasLastTradePrice(item)">
                  <animated-number
                    :value="contractPrice(item)"
                    :symbol="priceSymbol"
                  ></animated-number>
                </template>
                <template v-else> NEW </template>
              </div>
            </div>
          </template>
          <slot name="afterContent"></slot>
        </div>
      </div>
    </div>
    <div class="market-contract-info-v2__detailed" v-else-if="isDetailedLayout">
      <div
        class="market-contract-info-v2__detailed-image"
        :style="imageStyleModifiers"
        v-if="imageUrl"
      ></div>
      <div class="market-contract-info-v2__detailed-main">
        <div class="market-contract-info-v2__detailed-title" v-if="!!$slots.title || title">
          <slot name="title" v-if="!!$slots.title"></slot>
          <span v-else-if="title">{{ title }}</span>
        </div>
        <div class="market-contract-info-v2__detailed-content">
          <slot name="preContent"></slot>
          <template v-if="layout === MARKET_CONTRACT_INFO_VALUES_LAYOUT.BLANK_DETAILED">
            <slot name="content"></slot>
          </template>
          <slot name="afterContent"></slot>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script src="./market-contract-info-v2.js"></script>
<style src="./market-contract-info-v2.scss" lang="scss"></style>
